import PropTypes from 'prop-types';
import React from 'react';
import { connect as connectR } from 'react-redux';
import { Col, Row } from 'react-bootstrap';
import _ from 'lodash';
import EditLargeCard from '../main/edit-large-card';
import LeftSide from '../main/left-side';
import translate from '../translate';
import Navbar from '../navigation/navbar';
import VerticalNavigation from '../navigation/vertical-navigation';
import { PARTNER_MANAGER_CONTROL } from '../../util/enums';
import ProfileContactDataForm from './forms/profile-contact-data-form';
import {
    DeleteCreditNoteRecipient,
    LoadContractualContact,
    LoadCreditNoteRecipient,
    SaveContractualContact,
    SaveCreditNoteRecipient,
} from '../../store/partnerContactsSlice';
import {
    LoadContractDetails,
    LoadSettlementBillingDetails,
} from '../../store/userDetailsSlice';
import { LoadUser } from '../../store/userSlice';
import {
    REQUEST_FAILURE,
    REQUEST_INITIAL,
    REQUEST_PENDING,
    REQUEST_SUCCESS,
} from '../../store/network/managedRequest';
import Postit from '../main/postit';
import ContactAddressPreview from './forms/contact-address-preview';
import {
    LoadAccountingAreaDefaults,
    LoadSupportedTenants,
} from '../../store/accountingAreaDefaultsSlice';
import ProfileSettlementDetailsCard from './forms/profile-settlement-details-card';
import { usingFeatureWriteAccess } from '../../util/usingFeatureAccess';
import PbCardErrorElement from '../main/pb-card-error-element';
import ProfileContractDetailsCard from './forms/profile-contract-details-card';
import { PbRequest } from '../../store/pbRequest';
const POSSIBLE_STATUSES = [
    REQUEST_INITIAL,
    REQUEST_PENDING,
    REQUEST_SUCCESS,
    REQUEST_FAILURE,
];

class EditProfile extends React.Component {
    static propTypes = {
        LoadCreditNoteRecipient: PropTypes.func.isRequired,
        SaveCreditNoteRecipient: PropTypes.func.isRequired,
        DeleteCreditNoteRecipient: PropTypes.func.isRequired,
        LoadContractualContact: PropTypes.func.isRequired,
        SaveContractualContact: PropTypes.func.isRequired,
        contractualContact: PropTypes.shape({
            last_changed_at: PropTypes.number,
        }),
        creditNoteRecipient: PropTypes.shape({
            last_changed_at: PropTypes.number,
        }),
        contractualContactUpdateStatus:
            PropTypes.oneOf(POSSIBLE_STATUSES).isRequired,
        creditNoteRecipientUpdateStatus:
            PropTypes.oneOf(POSSIBLE_STATUSES).isRequired,
        fetchContractDetails: PropTypes.shape({
            country_id: PropTypes.number,
            last_changed_at: PropTypes.number,
        }),
        updateContractDetails: PropTypes.shape({
            status: PropTypes.oneOf(POSSIBLE_STATUSES).isRequired,
            errors: PropTypes.arrayOf(PropTypes.string),
        }),
        fetchBillingData: PropTypes.shape({
            last_changed_at: PropTypes.number,
        }),
        partnerManagerDetails: PropTypes.shape({
            control: PropTypes.oneOf(Object.values(PARTNER_MANAGER_CONTROL)),
        }),
        selectedPartner: PropTypes.shape({}),
        LoadContractDetails: PropTypes.func.isRequired,
        LoadSettlementBillingDetails: PropTypes.func.isRequired,
        strings: PropTypes.shape({
            _utils: PropTypes.shape({
                sprintf: PropTypes.func,
            }),
            userInfo: PropTypes.string,
            billingAddress: PropTypes.string,
            bank: PropTypes.string,
            beneficiaryDescription: PropTypes.string,
            recipientContactDescription: PropTypes.string,
            saveSection: PropTypes.string,
            settlement: PropTypes.string,
            contractDetails: PropTypes.string,
            changedNote: PropTypes.string,
        }).isRequired,
        LoadAccountingAreaDefaults: PropTypes.func.isRequired,
        LoadSupportedTenants: PropTypes.func.isRequired,
        LoadUser: PropTypes.func.isRequired,
    };

    state = {};

    componentDidMount() {
        this.props.LoadUser();
        this.props.LoadAccountingAreaDefaults();
        this.props.LoadSettlementBillingDetails();
        this.props.LoadContractDetails();
        this.props.LoadCreditNoteRecipient();
        this.props.LoadContractualContact();
        this.props.LoadSupportedTenants();
    }

    _getCountryId = () => {
        const contractDetails = this.props.fetchContractDetails;
        if (contractDetails) {
            return contractDetails.country_id;
        } else {
            return null;
        }
    };

    _handleContractualContactForm = (data) => {
        this.props.SaveContractualContact(data.contactData);
    };

    _handleCreditNoteRecipientForm = (data) => {
        if (data.chosenToUse) {
            this.props.SaveCreditNoteRecipient(data.contactData);
        } else {
            this.props.DeleteCreditNoteRecipient();
        }
    };

    _handleChangeContractualContact = ({ contactData }) => {
        this.setState({ contractualContact: contactData });
    };

    _handleChangeCreditNoteRecipient = ({ chosenToUse, contactData }) => {
        this.setState({
            creditNoteRecipientActive: chosenToUse,
            creditNoteRecipient: contactData,
        });
    };

    _handleCreditNoteRecipientCancel = () => {
        const creditNoteRecipient = this.props.creditNoteRecipient;
        const creditNoteRecipientActive = !!creditNoteRecipient;
        this.setState({ creditNoteRecipientActive, creditNoteRecipient });
    };

    _handleContractualContactCancel = () => {
        this.setState({
            contractualContact: this.props.contractualContact,
        });
    };

    _renderErrorElement = () => {
        if (this.props.updateContractDetails.status === REQUEST_FAILURE) {
            return (
                <PbCardErrorElement
                    errors={this.props.updateContractDetails.errors}
                />
            );
        }
        return null;
    };

    render() {
        const loadingContractualContact = !this.props.contractualContact;
        const loadingContractDetails = !this.props.fetchContractDetails;
        const loadingBillingData = !this.props.fetchBillingData;

        const contractualContact = this.props.contractualContact;
        let creditNoteRecipient =
            this.state.creditNoteRecipientActive !== undefined
                ? this.state.creditNoteRecipient
                : this.props.creditNoteRecipient;
        if (
            creditNoteRecipient &&
            this.props.creditNoteRecipient?.last_changed_at
        ) {
            creditNoteRecipient = {
                ...creditNoteRecipient,
                last_changed_at: this.props.creditNoteRecipient.last_changed_at,
            };
        }
        const contractDetails = _.extend({}, this.props.fetchContractDetails);
        const internalManager =
            this.props.partnerManagerDetails &&
            this.props.partnerManagerDetails.control ===
                PARTNER_MANAGER_CONTROL.ADMIN;

        if (
            loadingBillingData ||
            loadingContractDetails ||
            loadingContractualContact
        ) {
            return <div />;
        }

        const hasWriteContract = usingFeatureWriteAccess(
            this.props.selectedPartner,
            'MASTER_CONTRACT_DATA'
        );
        const hasWriteSettlement = usingFeatureWriteAccess(
            this.props.selectedPartner,
            'MASTER_SETTLEMENT_DETAILS'
        );
        const hasWriteRecipient = usingFeatureWriteAccess(
            this.props.selectedPartner,
            'MASTER_CREDIT_NOTE_RECIPIENT'
        );

        const contractDetailsNote =
            contractDetails.last_changed_at &&
            this.props.strings._utils.sprintf(
                this.props.strings.changedNote,
                new Date(contractDetails.last_changed_at).toLocaleString()
            );
        const billingDataNote =
            this.props.fetchBillingData?.last_changed_at &&
            this.props.strings._utils.sprintf(
                this.props.strings.changedNote,
                new Date(
                    this.props.fetchBillingData.last_changed_at
                ).toLocaleString()
            );
        const contactNote =
            contractualContact.last_changed_at &&
            this.props.strings._utils.sprintf(
                this.props.strings.changedNote,
                new Date(contractualContact.last_changed_at).toLocaleString()
            );
        const cnRecipientNote =
            creditNoteRecipient?.last_changed_at &&
            this.props.strings._utils.sprintf(
                this.props.strings.changedNote,
                new Date(creditNoteRecipient.last_changed_at).toLocaleString()
            );

        return (
            <Navbar nav>
                <Row>
                    <LeftSide addClass="">
                        <VerticalNavigation selected="profile" />
                    </LeftSide>
                    <Col xs={9} sm={9} md={9} lg={9}>
                        <Row>
                            <Col xs={8} sm={8} md={8} lg={8}>
                                <ProfileContractDetailsCard
                                    internalManager={internalManager}
                                    footnote={contractDetailsNote}
                                    disabled={!hasWriteContract}
                                />
                            </Col>
                            <Col xs={4} sm={4} md={4} lg={4} />
                            <Col xs={8} sm={8} md={8} lg={8}>
                                <EditLargeCard
                                    title={this.props.strings.userInfo}
                                    description={
                                        this.props.strings
                                            .beneficiaryDescription
                                    }
                                    handleSubmit={
                                        this._handleContractualContactForm
                                    }
                                    handleCancel={
                                        this._handleContractualContactCancel
                                    }
                                    validationEnabled
                                    error={
                                        this.props
                                            .contractualContactUpdateStatus ===
                                        REQUEST_FAILURE
                                    }
                                    submitLabel={this.props.strings.saveSection}
                                    footnote={contactNote}
                                    disabled={!hasWriteContract}
                                >
                                    <ProfileContactDataForm
                                        contactData={
                                            this.state.contractualContact ||
                                            contractualContact
                                        }
                                        handleChange={
                                            this._handleChangeContractualContact
                                        }
                                    />
                                </EditLargeCard>
                            </Col>
                            <Col xs={4} sm={4} md={4} lg={4}>
                                <Postit>
                                    <ContactAddressPreview
                                        contactData={
                                            this.state.contractualContact ||
                                            contractualContact
                                        }
                                        contractualCountryId={this._getCountryId()}
                                    />
                                </Postit>
                            </Col>
                            <Col xs={8} sm={8} md={8} lg={8}>
                                <ProfileSettlementDetailsCard
                                    internalManager={internalManager}
                                    footnote={billingDataNote}
                                    disabled={!hasWriteSettlement}
                                />
                            </Col>
                            <Col xs={4} sm={4} md={4} lg={4} />
                            <Col xs={8} sm={8} md={8} lg={8}>
                                <EditLargeCard
                                    title={this.props.strings.billingAddress}
                                    handleSubmit={
                                        this._handleCreditNoteRecipientForm
                                    }
                                    handleCancel={() =>
                                        this._handleCreditNoteRecipientCancel()
                                    }
                                    validationEnabled
                                    error={
                                        this.props
                                            .creditNoteRecipientUpdateStatus ===
                                        REQUEST_FAILURE
                                    }
                                    submitLabel={this.props.strings.saveSection}
                                    description={
                                        this.props.strings
                                            .recipientContactDescription
                                    }
                                    footnote={cnRecipientNote}
                                    disabled={!hasWriteRecipient}
                                >
                                    <ProfileContactDataForm
                                        contactData={creditNoteRecipient}
                                        handleChange={
                                            this
                                                ._handleChangeCreditNoteRecipient
                                        }
                                        optional
                                    />
                                </EditLargeCard>
                            </Col>
                            <Col xs={4} sm={4} md={4} lg={4}>
                                <Postit>
                                    <ContactAddressPreview
                                        contactData={creditNoteRecipient}
                                        contractualCountryId={this._getCountryId()}
                                    />
                                </Postit>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Navbar>
        );
    }
}

export default connectR(
    (store) => ({
        contractualContact: store.partnerContacts.contractualContract,
        contractualContactUpdateStatus:
            store.pbRequest[PbRequest.PUT_CONTRACTUAL_CONTACT].status,
        creditNoteRecipient: store.partnerContacts.creditNoteRecipient,
        creditNoteRecipientUpdateStatus:
            store.pbRequest[PbRequest.PUT_CREDIT_NOTE_RECIPIENT].status,
        fetchContractDetails: store.userDetails.contractDetails,
        updateContractDetails:
            store.pbRequest[PbRequest.UPDATE_CONTRACT_DETAILS],
        fetchBillingData: store.userDetails.settlementBillingDetails,
        partnerManagerDetails: store.partnerManager.partnerManagerDetails,
        selectedPartner: store.partnerManager.selectedPartner,
    }),
    {
        LoadContractualContact,
        SaveContractualContact,
        LoadCreditNoteRecipient,
        SaveCreditNoteRecipient,
        DeleteCreditNoteRecipient,
        LoadContractDetails,
        LoadSettlementBillingDetails,
        LoadAccountingAreaDefaults,
        LoadSupportedTenants,
        LoadUser,
    }
)(translate('EditProfile')(EditProfile));
